(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/desktop-pagination.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/desktop-pagination.js');
"use strict";


const {
  useState,
  useEffect,
  useRef,
  useMemo
} = React;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const CARDS_SMALL_SCREEN = 3;
const CARDS_LARGE_SCREEN = 4;
function splitIntoChunks(arr, chunkSize) {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
}
const DesktopPagination = _ref => {
  let {
    category
  } = _ref;
  const {
    games,
    columns: {
      am,
      md,
      xs
    } = {
      am: 4,
      md: 3,
      xs: 6
    }
  } = category;
  const {
    SlideIndicator,
    CategoryTitle
  } = svs.eInstant.shared.components;
  const TicketCard = svs.eInstant.components.TicketCard;
  const [activeSlide, setActiveSlide] = useState(0);
  const [cardsPerPage, setCardsPerPage] = useState(12 / md);
  const [direction, setDirection] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [targetSlide, setTargetSlide] = useState(0);
  const slideContainerRef = useRef(null);
  const updateCardsPerPage = () => {
    const width = window.innerWidth;
    if (width < 1024) {
      setCardsPerPage(CARDS_SMALL_SCREEN);
    } else {
      setCardsPerPage(CARDS_LARGE_SCREEN);
    }
  };
  useEffect(() => {
    setActiveSlide(0);
  }, [category.games]);
  useEffect(() => {
    if (am !== md) {
      updateCardsPerPage();
      window.addEventListener('resize', updateCardsPerPage);
    }
    return () => am !== md && window.removeEventListener('resize', updateCardsPerPage);
  }, []);
  const gamesChunks = useMemo(() => splitIntoChunks(games, cardsPerPage), [games, cardsPerPage]);
  const totalSlides = gamesChunks.length;
  const paginate = newIndex => {
    if (newIndex === activeSlide || isAnimating) return;
    const newDirection = newIndex > activeSlide ? 1 : -1;
    setDirection(newDirection);
    setTargetSlide(newIndex);
    setIsAnimating(true);

    if (slideContainerRef.current) {
      gsap.killTweensOf(slideContainerRef.current);
      if (newDirection === -1) {
        gsap.fromTo(slideContainerRef.current, {
          x: '-50%'
        }, {
          x: '0%',
          duration: 0.5,
          ease: 'power2.inOut',
          onComplete: () => {
            setActiveSlide(newIndex);
            setTargetSlide(newIndex);
            setIsAnimating(false);
          }
        });
      } else {
        gsap.to(slideContainerRef.current, {
          x: '-50%',
          duration: 0.5,
          ease: 'power2.inOut',
          onComplete: () => {
            setActiveSlide(newIndex);
            setTargetSlide(newIndex);
            gsap.set(slideContainerRef.current, {
              x: '0%'
            });
            setIsAnimating(false);
          }
        });
      }
    }
  };
  return React.createElement("div", {
    className: "desktop-pagination-card-container",
    "data-testid": "desktop-pagination-".concat(category.urlPath)
  }, React.createElement("div", {
    className: "u-flex u-flex-justify-content-between padding-bottom-half"
  }, React.createElement(CategoryTitle, {
    category: category,
    className: "margin-left-1-half"
  }), totalSlides > 1 && React.createElement(SlideIndicator, {
    activeSlide: activeSlide,
    className: "margin-right-1",
    isNextDisabled: activeSlide >= totalSlides - 1,
    isPrevDisabled: activeSlide <= 0,
    nextSlide: () => paginate(activeSlide + 1),
    prevSlide: () => paginate(activeSlide - 1),
    setActiveSlide: paginate,
    totalCount: totalSlides
  })), React.createElement("div", {
    className: isAnimating ? 'overflow-hidden' : ''
  }, React.createElement(Grid, null, React.createElement("div", {
    className: "u-flex u-flex-direction-row desktop-pagination-grid-chunks-wrapper ".concat(isAnimating ? 'desktop-pagination-animating' : 'desktop-pagination-static'),
    ref: slideContainerRef
  }, gamesChunks.map((chunk, chunkIndex) => {
    var _chunk$;
    const isActive = chunkIndex === activeSlide;
    const isNext = isAnimating && chunkIndex === targetSlide;
    const shouldShow = isActive || isNext;
    if (!shouldShow) return null;
    const order = direction === 1 ? isActive ? 0 : 1 : isActive ? 1 : 0;
    const orderClass = order === 0 ? 'slide-order-0' : 'slide-order-1';
    return React.createElement("div", {
      className: "slide-wrapper ".concat(isAnimating ? 'half-width' : 'full-width', " ").concat(orderClass),
      key: ((_chunk$ = chunk[0]) === null || _chunk$ === void 0 ? void 0 : _chunk$.cntTicketGameId) || chunkIndex
    }, React.createElement(GridRow, {
      className: "w100 desktop-pagination-margin-auto grid-flex-g-2"
    }, chunk.map((game, indexInChunk) => {
      const numberIndex = chunkIndex * cardsPerPage + indexInChunk;
      return React.createElement(GridCol, {
        am: am,
        className: "u-flex u-flex-justify-content-center",
        key: (game === null || game === void 0 ? void 0 : game.cntTicketGameId) || indexInChunk,
        md: md,
        xs: xs
      }, React.createElement(TicketCard, {
        className: "w100",
        isNumberedList: category.numberedList,
        number: numberIndex + 1,
        ticketConfig: game
      }));
    })));
  })))));
};
setGlobal('svs.eInstant.shared.components.DesktopPagination', DesktopPagination);

 })(window);